import { Breadcrumbs, Divider, Link, Typography } from "@material-ui/core";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { NavLink } from "react-router-dom";
import { FacebookShareButton, FacebookIcon } from "react-share";
import { TwitterShareButton, TwitterIcon } from "react-share";
import { LinkedinShareButton, LinkedinIcon } from "react-share";
import { PinterestShareButton, PinterestIcon } from "react-share";
import { toast } from "react-toastify";
import "../../../Assets/css/mjstatic.css";
import {
  base_url,
  currency,
  currencycode,
  postHeader,
} from "../../../Helpers/request";

import Author from "../../../Assets/images/user.png";
import Category from "../../../Assets/images/globe.png";
import Calender from "../../../Assets/images/calendar.png";

import { BsTelegram, BsPinterest, BsTwitter } from "react-icons/bs";
import { FaFacebookF, FaLinkedin } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { Share } from "@mui/icons-material";
import NoPage from "./NoPage";
import { useSelector } from "react-redux";

const BlogDetails = (props) => {
  const [blogdetaildata, setBlogdetaildata] = useState([]);
  const [show, setShow] = useState(null);

  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);

  useEffect(() => {
    const data = {
      currency_code: currencycode,
      blog_url: props.match.params.url,
    };
    axios
      .post(base_url + "/common/blog_detail", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setBlogdetaildata(res.data.data);

          setShow(true);
          toast.success(res.data.message, { autoClose: 3000 });
        } else {
          setBlogdetaildata([]);
          setShow(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  if (show != null) {
    return (
      <div className="blog_detail_page">
        {show ? (
          <>
            <Helmet>
              <meta charSet="utf-8" />
              <title>{blogdetaildata?.meta_title}</title>
              <meta
                name="description"
                content={blogdetaildata?.meta_description}
              />
              <meta
                name="keywords"
                content={blogdetaildata?.meta_keyword}
              ></meta>
            </Helmet>
            <div className="rcs_cart_section single-blog-breadcrumb mt-3">
              <Container>
                <Row>
                  <Col className="rcs_breadcrumb mb-2">
                    <Breadcrumbs
                      aria-label="breadcrumb"
                      className="justify-content-center"
                    >
                      <NavLink underline="hover" color="inherit" to="/">
                        Home
                      </NavLink>
                      <NavLink underline="hover" color="inherit" to="/blog">
                        Blog
                      </NavLink>
                      <Typography color="text.primary">
                        {blogdetaildata.blog_url}
                      </Typography>
                    </Breadcrumbs>
                  </Col>
                </Row>
              </Container>
            </div>
            <div className="">
              <Container>
                <Row className="w-100 m-auto">
                  <Col className="p-0">
                    <div className="rcs_blog_details_content blog-detail">
                      <h1>{blogdetaildata?.blog_name}</h1>
                      <div className="top-info mb-4 d-flex align-items-center justify-content-center">
                        <div>
                          <img src={Category} alt={blogdetaildata.img_alt} />
                          <h4>{blogdetaildata?.category_name}</h4>
                        </div>

                        <div>
                          <img src={Calender} alt="Calender" />
                          <h4>
                            {blogdetaildata?.created_at
                              ? moment(
                                  new Date(blogdetaildata?.publish_date)
                                ).format("MMMM DD, YYYY")
                              : ""}
                          </h4>
                        </div>

                        <div>
                          <img src={Author} alt="Author" />
                          <h4>By Admin</h4>
                        </div>
                      </div>

                      <Image
                        src={blogdetaildata?.blog_image}
                        alt={blogdetaildata.img_alt}
                        className="w-100 mb-3"
                      ></Image>

                      <p
                        dangerouslySetInnerHTML={{
                          __html: blogdetaildata?.blog_desc,
                        }}
                      />

                      <div className="share_this mt-5">
                        <h6>Share this: </h6>
                        <ul>
                          <li>
                            <a href="#">
                              <FacebookShareButton url={window.location.href}>
                                <FaFacebookF />{" "}
                              </FacebookShareButton>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <TwitterShareButton url={window.location.href}>
                                <BsTwitter />{" "}
                              </TwitterShareButton>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <PinterestShareButton
                                url={window.location.href}
                                media={window.location.href}
                              >
                                <BsPinterest />
                              </PinterestShareButton>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <LinkedinShareButton url={window.location.href}>
                                <FaLinkedin />
                              </LinkedinShareButton>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </>
        ) : (
          <NoPage />
        )}
      </div>
    );
  } else {
    return <></>;
  }
};
export default BlogDetails;
